import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
  Toggle,
} from "@fluentui/react";
import React, { useContext, useState, useCallback, useRef } from "react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import FilterPopUp from "./FilterPopUp";
import {
  LeftArrowFunction,
  RightArrowFunction,
} from "../../helpers/helpingFunctions";
import { dropdownStyles } from "../../helpers/initData";
import DropdownMoreIcon from "../../../../components/SVGComponents/DropdownMoreIcon";
import themeContext from "../../../../context/theme/ThemeContext";
import BasicViewerSwitch from "../../../../components/SVGComponents/BasicViewerSwitch";
import { BASIC_STUDYLIST, USERTYPES } from "../../../../constants/Constants";

import { t } from "i18next";
import SearchFilter from "./Components/SearchFilter";
import SortFilter from "./Components/SortFilter";
import ContentFilter from "./Components/ContentFilter";
import ApplyFilter from "./Components/ApplyFilter";
import NoOfImageFilter from "./Components/NoOfImageFilter";
import DataToggleFilter from "./Components/DataToggleFilter";
import HistoryCheckFilter from "./Components/HistoryCheckFilter";

const Filters = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    sortGlobal,
    setSortGlobal,
    filterInputValues,
    showFilters,
    setShowFilters,
    setApplyClick,
    filterBadges,
    setFilterBadges,
    removeBadgeFromFilter,
    storefilterBadges,
    setPatientDetail,
    trackApplyButton,
    setTrackApplyButton,
    patientNameBadgeShow,
    setPatientNameBadgeShow,
    handleEnterKeyPress,
    setFilterInputValues,
    storefilterInputValues,
    handleRefresh,
    roles
  } = useContext(studylistContext);

  const { theme, themeName, setThemeName, setTheme } = useContext(themeContext);

  return (
    <>
      <div className="study-list-sort-filter-container" 
      style={{
        padding : process.env.REACT_APP_VDC_PLATFORM === "true" ? "5px 10px 2px 10px" : "10px 10px",
        background: themeName === "light" ? "#EEEEEE":""
        }}>
        <div data-tut={"tour-filter-section"} className="section-filter">
          <div
            style={{
              display: "flex",
              width: storefilterBadges.length > 0 ? "93%" : "fit-content",
            }}
          >
            <SearchFilter />
            <SortFilter />
            <ContentFilter handleClearFilter={props.handleClearFilter} />
          </div>
        </div>
        <ApplyFilter handleClearFilter={props.handleClearFilter} />

        {(process.env.REACT_APP_PARTITION_MODE == "true" && process.env.REACT_APP_HYBRID_MODE === "false")  &&
          <DataToggleFilter />
        }
        
        {(process.env.REACT_APP_VDC_PLATFORM == "true" || process.env.REACT_APP_VDC_PLATFORM == true) && roles[0]  != USERTYPES.TYPIST &&
          <NoOfImageFilter />
        }

        {(process.env.REACT_APP_VDC_PLATFORM == "true" || process.env.REACT_APP_VDC_PLATFORM == true) && (roles[0]  === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) &&
          <HistoryCheckFilter />
        }
      </div>
    </>
  );
};

export default Filters;
